import React, { useEffect } from "react";
import { createUseStyles, useTheme } from "react-jss";

import styles from "./styles";

interface Props {
  steps: string[];
  showTitle: boolean;
}

export const Waypoints = (props: Props) => {
  const { steps, showTitle } = props;
  const useStyles = createUseStyles(styles);
  const theme = useTheme();
  const classes = useStyles({
    theme,
    ...props,
  });

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const closeButton = document.getElementById("close-button");
      if (
        event.key === "Tab" &&
        document.activeElement.id === `directionStep-${steps.length - 1}` &&
        closeButton
      ) {
        event.preventDefault();
        closeButton.focus();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.container} data-testid="direction-points-container">
      {steps?.length > 0 && showTitle && (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        <div className={classes.title} tabIndex={0}>
          Direction Points
        </div>
      )}
      {steps?.length > 0 &&
        steps.map((step: any, index: number) => {
          return (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            <div
              id={`directionStep-${index}`}
              className={classes.stopItem}
              tabIndex={0}
            >
              {step}
            </div>
          );
        })}
    </div>
  );
};
try {
    // @ts-ignore
    Waypoints.displayName = "Waypoints";
    // @ts-ignore
    Waypoints.__docgenInfo = { "description": "", "displayName": "Waypoints", "props": { "steps": { "defaultValue": null, "description": "", "name": "steps", "required": true, "type": { "name": "string[]" } }, "showTitle": { "defaultValue": null, "description": "", "name": "showTitle", "required": true, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Waypoints/Waypoints.tsx#Waypoints"] = { docgenInfo: Waypoints.__docgenInfo, name: "Waypoints", path: "src/shared/components/Waypoints/Waypoints.tsx#Waypoints" };
}
catch (__react_docgen_typescript_loader_error) { }